// extracted by mini-css-extract-plugin
export var wrapper = "GradientBorder-module--wrapper--YoZ4N";